import { createColumnHelper } from '@tanstack/react-table';

import { IntegratedApp } from './types';

export const helper = createColumnHelper<IntegratedApp>();
